<template>
  <v-card outlined class="rounded-lg">
    <v-card-title>
      Recalculation events coordiates
    </v-card-title>
    <v-card-text>
      <v-autocomplete
        v-model="selectedMapId"
        :items="mapIds"
        :hint="createdAtHint"
        label="Map ID"
        filled
        dense
        persistent-hint
        item-text="alias"
        item-value="mapId"
        hide-detailse="auto"
      />
      <v-autocomplete
        v-model="selectedBuild"
        :items="builds"
        label="Build"
        hide-details
        filled
        item-text="build_id"
        item-value="build_id"
      />
    </v-card-text>
    <v-card-actions>
      <v-btn
        dark
        color="primary"
        :loading="loading"
        :disabled="selectedBuild === null"
        @click="recalculation"
      >
        Recalculation
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    data () {
      return {
        mapIds: [],
        builds: [],
        loading: false,
        selectedMapId: null,
        selectedBuild: null
      }
    },
    async created () {
      const { data } = await this.$axios.get(this.$store.getters.projectPath + '/configs/multi-map')
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.mapIds = data
        if (data.length) {
          this.selectedMapId = data[0].mapId
        }
      }
    },
    computed: {
      createdAtHint () {
        const val = this.mapIds.find(mapId => mapId.mapId === this.selectedMapId)
        if (val) {
          return val.createdAt
        } else {
          return ''
        }
      }
    },
    watch: {
      async selectedMapId () {
        this.selectedTimelineData = {
          build_id: null,
          user_id: null,
          session_id: null
        }

        await this.getSessions()
      },
    },
    methods: {
      async getSessions () {
        const { data } = await this.$axios.get(
          `${this.$store.getters.projectPath}/telemetry/data-for-filters/${this.selectedMapId}`
        ).catch(error => ({ data: { err: true, message: error.response.data } }))

        if (data.err) {
          this.$toasted.error(data.message)
        } else {
          this.builds = data
          if (data.length && !this.selectedBuild) {
            this.selectedBuild = data[0].build_id
          }
        }
      },
     async recalculation () {
        this.loading = true

        const { data } = await this.$axios.post(this.$store.getters.projectPath + '/telemetry/recalculation/' + this.selectedMapId, {
          build_id: this.selectedBuild
        })
        .catch(error => ({ data: { err: true, message: error.response.data } }))

        if (data.err) {
          this.$toasted.error(data.message)
        } else {
          this.$toasted.success('Success')
        }
        this.loading = false
      }
    }
  }
</script>